// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const vaccinations = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_VACCINE':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'SHOW_DATA_VACCINE':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_VACCINE':
      return { ...state }
    case 'EDIT_VACCINE':
      return { ...state }
    case 'DELETE_VACCINE':
      return { ...state }
    default:
      return { ...state }
  }
}
export default vaccinations
